import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["value", "id"]
const _hoisted_3 = {
  key: 2,
  class: "vb-input__block"
}
const _hoisted_4 = ["type", "value", "id"]
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vb-input", { rtl: _ctx.rtl, error: _ctx.error }]),
    style: _normalizeStyle(_ctx.blockStyle)
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          style: _normalizeStyle(_ctx.labelStyle),
          class: _normalizeClass(["vb-input__label", { inline: _ctx.labelInline, rtl: _ctx.rtl, error: _ctx.error }])
        }, _toDisplayString(_ctx.label), 15, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.type === 'textarea')
      ? (_openBlock(), _createElementBlock("textarea", _mergeProps({
          key: 1,
          class: ["vb-input__field", { error: _ctx.error }],
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
        }, _ctx.$attrs, {
          value: _ctx.modelValue,
          style: _ctx.fieldStyle,
          id: _ctx.id
        }), null, 16, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("input", _mergeProps({
            class: ["vb-input__field", { error: _ctx.error }],
            type: _ctx.setType,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
          }, _ctx.$attrs, {
            value: _ctx.modelValue,
            style: _ctx.fieldStyle,
            id: _ctx.id
          }), null, 16, _hoisted_4),
          (_ctx.hasButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["vb-input__btn", { rtl: _ctx.rtl, error: _ctx.error }]),
                type: "button",
                style: _normalizeStyle(_ctx.buttonStyle),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onButtonClick && _ctx.onButtonClick(...args)))
              }, [
                (_ctx.type === 'password' || _ctx.type === 'search')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["vb-input__icon", { password: _ctx.type === 'password', search: _ctx.type === 'search', showPassword: _ctx.showPassword }])
                    }, null, 2))
                  : _createCommentVNode("", true),
                (_ctx.hasButton && _ctx.buttonText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.buttonText), 1))
                  : _createCommentVNode("", true)
              ], 6))
            : _createCommentVNode("", true)
        ])),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 3,
          class: "vb-input__errorMessage",
          style: _normalizeStyle(_ctx.errorMessageStyle)
        }, _toDisplayString(_ctx.error), 5))
      : _createCommentVNode("", true)
  ], 6))
}